import React from 'react';

import {translate} from 'iss/strings';
import {editRecurrences} from 'iss/service/EvaluationActivationService';
import {ActivationList} from 'iss/widgets/ActivationList';
import {WarningBox} from 'iss/widgets/MessageBox';
import {RecurrenceDatesSelector, toActivationRecurrenceDates} from 'iss/widgets/activation/DateSelectorSections';
import {ModalForm} from 'iss/widgets/batchOps/ModalForm';
import {listFailuresWithMessage} from 'iss/widgets/batchOps/activation/BatchOpFailure';

const modifyRecurrences = {
    id: "modifyRecurrences",
    title: "activationOperations.modifyRecurrences.title",
    progressMessage: "activationOperations.modifyRecurrences.progressMessage",
    components: {
      settings: ({operationTargets, onCancel, startOperation}) =>
      <ModalForm proceedText={translate('activationOperations.modifyRecurrences.proceedText')} proceedLook="danger"
        onSubmit={(formData) => startOperation(editRecurrences(operationTargets, getRecurrenceModificationCommand(formData)))}
        onCancel={onCancel}>
        <>
          <WarningBox message={translate('activationOperations.modifyRecurrences.isPermanentAndBad')} />
          <p>{translate('activationOperations.modifyRecurrences.confirmMessage', {count: operationTargets.length})}</p>
        </>
        <RecurrenceDatesSelector />
        <ActivationList activations={operationTargets} />
      </ModalForm>,
      success: <p>{translate("activationOperations.modifyRecurrences.success")}</p>,
      failure: listFailuresWithMessage("activationOperations.modifyRecurrences.failure")
    },
};

function getRecurrenceModificationCommand({recurrenceType, recurrenceDates}) {
  const dates = toActivationRecurrenceDates({recurrenceType, recurrenceDates});
  return {
    recurrenceType,
    'recurrenceDates': dates,
  };
}

export default modifyRecurrences;



// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/batchOps/activation/modifyRecurrences.jsx